import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-splitline-config',
  templateUrl: './d-splitline-config.component.html',
  styles: []
})
export class DSplitlineConfigComponent extends DynamicComponentBase {
  static KEY = 'd-splitline-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
